
const state = {
  loading: false
}

const mutations = {
  load( state, status ) {
    state.loading = status
  },
}

const getters = {
}

const actions = {
  load( { commit }, status ) {
    commit( 'load', status )
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/loading.js